import { useTranslation } from "react-i18next";

function Frame425({ checkoutPayment, setCheckoutPayment }) {
  const { t } = useTranslation(); // Initialize translation hook

  return (
    <div className="checkout-type mt-0 pe-sm-5 mb-3">
      <div className="address-type" onClick={() => setCheckoutPayment(false)}>
        <div className="num chosen">1</div>
        <div className="d-flex flex-column contain">
          <span>{t("frame425.addressTitle")}</span>
          <span>{t("frame425.addressSubtitle")}</span>
        </div>
      </div>
      <div className="line"></div>
      <div className="payment-type">
        <div className={`num ${checkoutPayment && "chosen"}`}>2</div>
        <div className="d-flex flex-column contain">
          <span>{t("frame425.paymentTitle")}</span>
          <span>{t("frame425.paymentSubtitle")}</span>
        </div>
      </div>
    </div>
  );
}

export default Frame425;
